import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '@/lib/api';

const AuthCtx = createContext(null);

export function AuthProvider(props) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeChildId, setActiveChildId] = useState(() => localStorage.getItem('lq_active_child') || null);
    const [childProfiles, setChildProfiles] = useState([]);

    const bootstrap = useCallback(async () => {
        const t = localStorage.getItem('lq_token');
        if (!t) { setLoading(false); return; }
        try {
            const { data } = await api.get('/auth/session');
            setUser(data.user);
            const c = await api.get('/me/children');
            setChildProfiles(c.data.children || []);
        } catch {
            localStorage.removeItem('lq_token');
        } finally { setLoading(false); }
    }, []);

    useEffect(() => { bootstrap(); }, [bootstrap]);

    const login = async (email, password) => {
        const { data } = await api.post('/auth/login', { email, password });
        localStorage.setItem('lq_token', data.token);
        setUser(data.user);
        try {
            const c = await api.get('/me/children');
            setChildProfiles(c.data.children || []);
        } catch { /* ignore */ }
        return data.user;
    };
    const register = async (payload) => {
        const { data } = await api.post('/auth/register', payload);
        localStorage.setItem('lq_token', data.token);
        setUser(data.user);
        return data.user;
    };
    const logout = () => {
        localStorage.removeItem('lq_token');
        localStorage.removeItem('lq_active_child');
        setUser(null); setChildProfiles([]); setActiveChildId(null);
    };
    const refreshChildren = async () => {
        const c = await api.get('/me/children');
        setChildProfiles(c.data.children || []);
        return c.data.children || [];
    };
    const refreshUser = async () => {
        try {
            const { data } = await api.get('/auth/session');
            setUser(data.user || data);
            return data.user || data;
        } catch { return null; }
    };
    const pickActiveChild = (id) => {
        setActiveChildId(id);
        if (id) localStorage.setItem('lq_active_child', id);
        else localStorage.removeItem('lq_active_child');
    };

    return (
        <AuthCtx.Provider value={{
            user, loading, login, register, logout,
            children: childProfiles, refreshChildren, refreshUser,
            activeChildId, pickActiveChild,
        }}>
            {props.children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
